import { render, staticRenderFns } from "./activeForm.vue?vue&type=template&id=5510e1ae&scoped=true&"
import script from "./activeForm.vue?vue&type=script&lang=js&"
export * from "./activeForm.vue?vue&type=script&lang=js&"
import style0 from "./activeForm.vue?vue&type=style&index=0&id=5510e1ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5510e1ae",
  null
  
)

component.options.__file = "activeForm.vue"
export default component.exports